import React from 'react';


class BI extends React.Component{
    render(){
        return (
            <React.Fragment>
              <div className="Page">
                 <div className="OneApp">
                        <h5>Business Intelligence</h5>
                        
                        <p align="center">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/R9BPb-BGPNQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;" allowfullscreen></iframe>
                        </p>
                        
                        
                        
                        <p align="left"></p>
                        
                        <p align="left">Puedes ver el repositorio dando click <a href="https://github.com/BrandonGrimaldoM/BIQlikSense" target="_blank" rel='noreferrer'>AQUI.</a></p>
                        
                        <div className="space"></div>
                        
                        
                 </div>
                 
                
             </div>
          
            </React.Fragment>
        ); 
    }
}

export default BI;